import {
  Button,
  Modal,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Box } from '@mui/system';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

interface IModal {
  isVisible: boolean;
  closeModal: () => void;
  deleteModal: () => void;
  texts: any;
}

export const DeleteModal = (props: IModal) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  const dictionary = useDictionary(Dictionary, DICTIONARY.PERSONAL_DETAILS);

  return (
    <Modal open={props.isVisible}>
      <Paper
        sx={{
          boxShadow: '0px 3px 21px 0px #2D70D926',
          padding: isDesktop ? '80px 60px 56px 60px' : '38px 16px 48px 16px',
          maxWidth: '550px',
          mb: '64px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          width: '80%',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: '20px',
            left: '20px',
            fontSize: '25px',
            cursor: 'pointer',
          }}
          onClick={props.closeModal}
        >
          X
        </span>
        <Typography>{dictionary.deleteModalFirstParagraph}</Typography>
        <Typography sx={{ fontWeight: 'bold', mb: '30px' }}>
          {dictionary.deleteModalWitnessFirstLine} {props.texts?.name}
        </Typography>
        <Typography>{dictionary.deleteModalWitnessSecondLine}</Typography>
        <Typography>{dictionary.deleteModalWitnessThirdLine}</Typography>
        <Typography sx={{ fontWeight: 'bold', mt: '30px' }}>
          {dictionary.deleteModalWitnessLastLine}
        </Typography>
        <Box
          sx={{ display: 'flex', justifyContent: 'space-around', mt: '50px' }}
        >
          <Button variant={'outlined'} onClick={props.deleteModal}>
            {dictionary.deleteModalConfirmButton}
          </Button>
          <Button onClick={props.closeModal}>
            {dictionary.deleteModalCancelButton}
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};
